module.exports = __webpack_public_path__ + "static/media/4.fbbcb098.png";